import React from "react";
import SearchListItem from "../SearchListItem/SearchListItem";
import "./SearchList.css";
import object from "./search.json";

const SearchList = () => {
  return (
    <div className="search-list">
      {object.map((item, index) => (
        <SearchListItem
          key={index}
          name={item.name}
          distance={item.distance}
          tag={item.tag}
          type={item.type}
          description={item.description}
          free_cancel={item.free_cancel}
          price={item.price}
          rate={item.rate}
          rate_text={item.rate_text}
          image_url={item.image_url}
        />
      ))}
    </div>
  );
};

export default SearchList;
